import _slicedToArray from "@babel/runtime-corejs2/helpers/slicedToArray";
import _objectWithoutProperties from "@babel/runtime-corejs2/helpers/objectWithoutProperties";
import _toConsumableArray from "@babel/runtime-corejs2/helpers/toConsumableArray";
import _extends from "@babel/runtime-corejs2/helpers/extends";
import _defineProperty from "@babel/runtime-corejs2/helpers/defineProperty";
import _objectSpread from "@babel/runtime-corejs2/helpers/objectSpread2";
var _excluded = ["renderOption", "options", "onChange", "isReadonly"];
/** @jsxRuntime classic */
/** @jsx jsx */
/* eslint-disable no-param-reassign */
import * as React from 'react';
import { jsx } from '@emotion/react';
import _ReactSelect, { components as defaultComponents } from 'react-select';
import { useTranslator } from '@gandi/translate';
import { Base } from '@gandi/ui';
import * as theme from '../theme';
import { breakpoints, colors, spacings } from '../theme/ui';
import { useReadonly } from '../../hooks';
var ReactSelect = /*#__PURE__*/React.memo(_ReactSelect);
var styles = _objectSpread(_objectSpread({}, theme.styles), {}, {
  option: function option() {
    return {
      '&:not(:last-child)': {
        borderBottomWidth: '1px',
        borderBottomStyle: 'solid',
        borderBottomColor: colors.grey
      }
    };
  },
  valueContainer: function valueContainer(provided, state) {
    if (state.selectProps.isMulti) {
      // $FlowFixMe[prop-missing]
      return theme.styles.valueContainer(provided, state);
    }
    return _objectSpread(_objectSpread({}, provided), {}, {
      padding: false
    });
  },
  placeholder: function placeholder(provided, state) {
    if (state.selectProps.isMulti) {
      return provided;
    }
    return _objectSpread(_objectSpread({}, provided), {}, _defineProperty({
      paddingLeft: spacings.mobile.small
    }, "@media (min-width: ".concat(breakpoints.small, ")"), {
      paddingLeft: spacings.small
    }));
  },
  singleValue: function singleValue(provided) {
    return _objectSpread(_objectSpread({}, provided), {}, {
      position: false,
      top: false,
      marginLeft: false,
      marginRight: false,
      transform: false,
      width: '100%'
    });
  },
  group: function group() {
    return {
      '&:not(:first-child)': {
        borderTopWidth: '1px',
        borderTopStyle: 'solid',
        borderTopColor: colors.grey
      }
    };
  },
  groupHeading: function groupHeading(provided, state) {
    return _objectSpread(_objectSpread({}, theme.styles.groupHeading(provided, state)), {}, {
      backgroundColor: colors.greyLighter,
      borderBottomWidth: '1px',
      borderBottomStyle: 'solid',
      borderBottomColor: colors.grey
    });
  }
});
function SingleValue(props) {
  var _props$selectProps = props.selectProps,
    menuIsOpen = _props$selectProps.menuIsOpen,
    isDisabled = _props$selectProps.isDisabled,
    isReadonly = _props$selectProps.isReadonly,
    render = _props$selectProps.uiRenderOption,
    data = props.data,
    isSelected = props.isSelected;
  return jsx(defaultComponents.SingleValue, props, menuIsOpen ? null : jsx(Base, null, typeof render === 'function' ? render(data, {
    isSelected: isSelected,
    asValue: true,
    isDisabled: isDisabled,
    isReadonly: isReadonly
  }) : null));
}
function Option(props) {
  var selectProps = props.selectProps,
    data = props.data,
    isSelected = props.isSelected,
    isFocused = props.isFocused;
  var render = selectProps.uiRenderOption;
  var optionTheme = function () {
    if (isFocused) {
      return {
        backgroundColor: 'grey-lighter',
        highlight: isSelected ? 'anthracite' : 'green'
      };
    }
    if (isSelected) {
      return {
        hoverBackgroundColor: 'grey-lighter',
        highlight: 'anthracite'
      };
    }
    return {
      hoverBackgroundColor: 'grey-lighter',
      hoverHighlight: 'green'
    };
  }();
  return jsx(defaultComponents.Option, props, jsx(Base, _extends({
    interactive: true
  }, optionTheme), typeof render === 'function' ? render(data, {
    isSelected: isSelected,
    asValue: false
  }) : null));
}
var components = _objectSpread(_objectSpread({}, theme.components), {}, {
  SingleValue: SingleValue,
  Option: Option
});
var setValueFirst = function setValueFirst(value, options) {
  if (!value) {
    return options;
  }
  var idx = options.indexOf(value);
  if (idx <= 0) {
    return options;
  }
  var updated = _toConsumableArray(options);
  updated.splice(idx, 1);
  // $FlowFixMe[incompatible-call]
  updated.unshift(value);
  return updated;
};
function Custom(props) {
  var renderOption = props.renderOption,
    optionsProp = props.options,
    onChange = props.onChange,
    isReadonly = props.isReadonly,
    extraProps = _objectWithoutProperties(props, _excluded);
  var _useTranslator = useTranslator(),
    __ = _useTranslator.__;
  var readOnlyProps = useReadonly({
    isReadonly: isReadonly
  });
  var _React$useState = React.useState(function () {
      return setValueFirst(props.defaultValue, optionsProp);
    }),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    options = _React$useState2[0],
    setOptions = _React$useState2[1];

  // Update the available options and the default value when their value change.
  React.useEffect(function () {
    setOptions(setValueFirst(props.value || props.defaultValue, optionsProp));
    // WARN: Do not set `props.defaultValue` as a dependency
    // in order to correctly ignore this props change.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [optionsProp, props.value]);

  // Memoize the `handleChange` callback.
  var handleChange = React.useCallback(function (value, params) {
    setOptions(setValueFirst(value, optionsProp));
    if (typeof onChange === 'function') {
      onChange(value, params);
    }
  }, [optionsProp, setOptions, onChange]);
  return (
    // $FlowFixMe[cannot-spread-inexact]
    jsx(ReactSelect, _extends({
      options: options,
      onChange: handleChange,
      isReadonly: isReadonly,
      uiRenderOption: renderOption,
      theme: theme.theme,
      styles: styles,
      components: components,
      placeholder: __('Select...')
    }, readOnlyProps, extraProps))
  );
}
export default /*#__PURE__*/React.memo(Custom);